(function ($, document, window) {
  "use strict";

  $(function () {
    let section = $('#content section');

    if ($('body').hasClass('page-template-page-sidebar')) {
      section = $('#content > .container > .row > .col-12:last-of-type section');
    }

    // Loops through each content section and finds all the h2s to create in page nav.
    section.each(function() {
      const h2s = $(this).find("h2:not(.qld__inpage-nav-links__heading):not(.qld__page-alerts--heading):not(.accordion-header)");

      // Loop through all h2s, create id and then append to in page links menu
      h2s.each(function(h2) {
        const text = $(this).text();
        const textLower = text.toLowerCase().replace(/\s+/g, '-');
        $(this).attr('id', textLower);

        $('.qld__inpage-nav-links > .qld__link-list').append(`<li><a href="#${textLower}">${text}</a></li>`)
      });
    });

    // If URL has a hash, scroll to it after IDs are set
    // Use getElementById to avoid jQuery CSS selector errors with special chars like ()
    if (window.location.hash) {
      const el = document.getElementById(window.location.hash.slice(1));
      if (el) {
        $('html, body').animate({
          scrollTop: $(el).offset().top
        }, 0);
      }
    }
  });
})(jQuery, document, window);
